import React from 'react';
import './App.css';
import { Route, Routes } from 'react-router-dom';

import PageHome from './pages/home';
import PageBuatProfile from './pages/profile/buatProfile';
import PageAnalisa from './pages/analisa';
import PageCapture from './pages/capture';
import PageProfile from './pages/profile/profile';
import PageListProduk from './pages/produk/listProduk';
import PageDetailProduk from './pages/produk/detailProduk';

import { ProfileProvider } from './components/context/profileContext';
import PageLogin from './pages/login';

function App() {
  return (
    <div className="font-poppins">
      <ProfileProvider>
        <Routes>
          <Route path="/" element={<PageHome />} />
          <Route path="/sales" element={<PageLogin />} />
          <Route path="/profile" element={<PageProfile />} />
          <Route path="/biodata" element={<PageBuatProfile />} />
          <Route path="/hasil-analisa" element={<PageAnalisa />} />
          <Route path="/produk" element={<PageListProduk />} />
          <Route path="/detail-produk" element={<PageDetailProduk />} />
          <Route path="/scan" element={<PageCapture />} />
        </Routes>
      </ProfileProvider>
    </div>
  );
}

export default App;
